import { CornerUpRight } from "lucide-react";
import type { MessageNode } from "./utils";
import { extractToolCallError } from "@/modules/agents/components/helpers/richActionHelpers";
import { TimelineStepShell } from "./TimelineStepShell";

interface TimelineRoutedMessageStepProps {
  node: MessageNode;
  isExpanded: boolean;
  onToggle: () => void;
  isThreadActive: boolean;
}

/**
 * A send_message_to_thread call that is still running or failed, as a timeline
 * step. Completed moves render as a card under the agent's reply instead.
 * @param props.node - The send_message_to_thread call
 * @param props.isExpanded - Whether the failure detail is shown
 * @param props.onToggle - Toggles the failure detail
 * @param props.isThreadActive - Whether the thread is currently running
 * @returns The timeline row
 */
export function TimelineRoutedMessageStep({
  node,
  isExpanded,
  onToggle,
  isThreadActive,
}: TimelineRoutedMessageStepProps) {
  const error = extractToolCallError(node.toolResult);

  if (error) {
    return (
      <TimelineStepShell
        icon={CornerUpRight}
        label="Couldn't move to another conversation"
        isExpanded={isExpanded}
        onToggle={onToggle}
      >
        <p className="whitespace-pre-wrap break-words text-xs text-muted-foreground">
          {error}
        </p>
      </TimelineStepShell>
    );
  }

  return (
    <TimelineStepShell
      icon={CornerUpRight}
      label="Moving to another conversation"
      isInProgress={isThreadActive && !node.toolResult}
    />
  );
}
